import { useQuery } from '@tanstack/react-query';

import { useCard } from '@/react-query/hooks/query/use-card';
import { getDebitCardSpendingLimits, getDebitProductSpendingLimits } from '@/react-query/services/spending-limits';

import { Card, CardType, DebitSpendingLimit } from '@generated-types';
import { useCardId } from '@hooks/card/use-card-id';
import { useCardType } from '@hooks/card/use-card-type';

export const useCardSpendingLimits = (explicitCardId?: string) => {
    const implicitCardId = useCardId();
    const cardType = useCardType();
    const card = useCard();

    const cardId = explicitCardId ?? implicitCardId;

    return useQuery<DebitSpendingLimit>({
        queryKey: ['debitCardSpendingLimits', cardId],
        queryFn: () => getDebitCardSpendingLimits(cardId!),

        enabled:
            cardId !== undefined &&
            cardType === CardType.DEBIT &&
            card.data?.allowedOperations?.getSpendingLimit === true,
    });
};

export const useDebitProductSpendingLimits = (card: Card | undefined) => {
    const productCode = card?.product?.code;

    return useQuery<DebitSpendingLimit>({
        queryKey: ['debitProductSpendingLimits', productCode],
        queryFn: () => getDebitProductSpendingLimits(productCode!),

        enabled: typeof productCode !== 'undefined' && card?.type === CardType.DEBIT,
    });
};
